export default class CacheableSet {
  /**
   * @param {Function} keyFunction function used to generated enqueued items key
   */
  constructor(keyFunction = (value => value)) {
    this.longTermMemory = new Set();
    this.shortTermMemory = [];
    this.keyFunction = keyFunction;
  }

  enqueue = (value) => {
    const key = this.keyFunction(value);
    if (!this.longTermMemory.has(key)) {
      this.longTermMemory.add(key);
      this.shortTermMemory.push(value);
    }
  };

  /**
   * @returns {Array}
   */
  popAll = () => {
    const shortTermMemoryCopy = [...this.shortTermMemory];
    this.shortTermMemory.length = 0;
    return shortTermMemoryCopy;
  };

  clear = () => {
    this.shortTermMemory.length = 0;
    this.longTermMemory.clear();
  };
}
